<template>
  <a-dialog v-model="show" scrollable persistent max-width="500">
    <v-card flat>
      <!-- Toolbar -->
      <v-toolbar class="pa-0" color="primaryLight1" flat dark height="50px">
        <span>{{ $t("lblGroup") }}</span>
        <v-spacer></v-spacer>
        <CloseIcon @click="onClose" />
      </v-toolbar>

      <!-- Form -->
      <v-card-text class="black--text">
        <v-form ref="refAddGroupName" v-model="valid" lazy-validation @submit.prevent="onOkClick">
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="internalForm.name"
                :rules="requiredRules"
                required
                dense
                class="mt-4"
                filled
                :label="$t('lblGroupName')"
                :counter="300"
                @keydown.enter.prevent="onOkClick"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider />

      <!-- Actions -->
      <v-card-actions class="justify-center">
        <v-spacer></v-spacer>

        <!-- OK Button -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              ref="primaryButton"
              color="primaryDark"
              class="font-weight-bold"
              small
              @click="onOkClick"
            >
              <span>{{ $t("btnOk") }}</span>
            </a-btn>
          </template>
          <span>{{ $t("btnOk") }}</span>
        </v-tooltip>

        <!-- Cancel Button -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              small
              color="secondary"
              class="font-weight-bold ml-2"
              @click="onClose"
            >
              <span>{{ $t("btnLabelCancel") }}</span>
            </a-btn>
          </template>
          <span>{{ $t("btnLabelCancel") }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </a-dialog>
</template>

<script>
export default {
  name: "AddGroup",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    groupForm: {
      type: Object,
      default: () => ({}),
    },
    groupList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      valid: true,
      internalForm: {
        name: "",
      },
      requiredRules: [
        (v) => !!(v ? v.trim() : "") || this.$t("ruleGroupNameReq"),
        (v) =>
          (v && v.length <= 300) ||
          this.$t("validation.maxCharacters", { count: 300 }),
        (v) =>
          this.isUniqueGroupName(v) || this.$t("validation.duplicateGroupName"),
      ],
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val || false);
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.setInternalForm();
      }
    },
    groupForm: {
      handler() {
        if (this.show) {
          this.setInternalForm();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    setInternalForm() {
      this.internalForm = JSON.parse(JSON.stringify(this.groupForm));
    },
    isUniqueGroupName(name) {
      const trimmedName = (name || "").trim().toLowerCase();
      const currentId = this.groupForm?.id;

      return !this.groupList.some(
        (group) =>
          group.name.trim().toLowerCase() === trimmedName &&
          group.id !== currentId
      );
    },
    onOkClick() {
      if (this.$refs.refAddGroupName.validate()) {
        this.$emit("addGroup", { ...this.internalForm });
        this.onClose();
      }
    },
    onClose() {
      this.$refs.refAddGroupName.reset();
      this.$refs.refAddGroupName.resetValidation();
      this.show = false;
    },
  },
};
</script>
